export type VerifastStatus = {
  id_verify_status?: string | null;
  completion_status?: string | null;
  approval_status?: string | null;
  error_message?: string | null;
  session_id?: string | null;
};

export function isVerifastIdentityFailure(
  status: VerifastStatus | null | undefined,
): boolean {
  const rawStatus = String(status?.id_verify_status || "").toLowerCase();
  // Final approval always wins over a stale error_message from an earlier webhook.
  if (rawStatus === "complete") return false;

  const error = String(status?.error_message || "").toLowerCase();
  if (rawStatus === "failed") {
    if (error.includes("session.rejected")) return false;
    return true;
  }

  return (
    error.includes("verification.identity.failed") ||
    error.includes("session.expired")
  );
}

/**
 * Verifast can emit session.rejected and session.approved within ~1s (same second).
 * Keep polling through a transient session.rejected so we pick up the final approval.
 */
export function shouldStopVerifastPolling(
  status: VerifastStatus | null | undefined,
): boolean {
  const rawStatus = String(status?.id_verify_status || "").toLowerCase();
  if (rawStatus === "complete" || rawStatus === "needs_review") return true;

  if (rawStatus === "failed") {
    const error = String(status?.error_message || "").toLowerCase();
    if (error.includes("session.rejected")) return false;
    return true;
  }

  const error = String(status?.error_message || "").toLowerCase();
  if (
    error.includes("verification.identity.failed") ||
    error.includes("session.expired")
  ) {
    return true;
  }

  return false;
}
